/*
 * src/hooks/useAllCreditTransferTypes.js
 * Description: Query transfer fee configuration for a particular tenant
 * Copyright (c) 2021 PredictiveUX
 */
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const GET_ALL_TRANSFER_FEE_CONFIGS = gql`
  query AllTransferFeeConfigsByTenantId($identifier: String!) {
    allTransferFeeConfigs(where: { tenant: { identifier: $identifier } }) {
      id
      clientPays
      amount
      tenant {
        name
      }
    }
  }
`;

/**
 * i.e. "localhost" is the canonical domain identifier
 * @param {*} domain
 * @returns
 */
const useAllTransferFeeConfigs = (domain) => {
  const { loading, error, data, refetch } = useQuery(
    GET_ALL_TRANSFER_FEE_CONFIGS,
    {
      fetchPolicy: "no-cache",
      variables: {
        identifier: domain || "",
      },
    }
  );

  return { loading, error, data: data?.allTransferFeeConfigs || null, refetch };
};

export default useAllTransferFeeConfigs;
